import { render } from "./accordionItem.vue?vue&type=template&id=9adefc78&scoped=true"
import script from "./accordionItem.vue?vue&type=script&lang=js"
export * from "./accordionItem.vue?vue&type=script&lang=js"

import "./accordionItem.vue?vue&type=style&index=0&id=9adefc78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adefc78"]])

export default __exports__